// LOCATION: admin-portal/src/components/Sidebar.jsx

import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { db, auth } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import './Sidebar.css'; 

const Sidebar = () => {
  const [permissions, setPermissions] = useState(null);

  useEffect(() => {
    const fetchPermissions = async () => {
      const user = auth.currentUser;
      if (user) {
        const docRef = doc(db, 'admin_access', user.email);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setPermissions(docSnap.data().permissions || {});
        } else {
          setPermissions({});
        }
      }
    };
    fetchPermissions();
  }, []);

  const handleLogout = async () => {
    await auth.signOut();
    window.location.href = '/login'; 
  };

  if (!permissions) return <div className="sidebar">Loading...</div>;

  return (
    <div className="sidebar">
      <div className="logo">Ccuring Admin</div>
      
      <nav style={{ flex: 1 }}>
        {(permissions.super_admin) && (
          <NavLink to="/staff" className={({ isActive }) => isActive ? "active-link" : ""}>
            👔 Staff Management
          </NavLink>
        )}

        {(permissions.user_management || permissions.super_admin) && (
          <NavLink to="/users" className={({ isActive }) => isActive ? "active-link" : ""}>
            👥 User Management
          </NavLink>
        )}

        {(permissions.events || permissions.super_admin) && (
          <>
            <NavLink to="/events" className={({ isActive }) => isActive ? "active-link" : ""}>
              📈 Event Analytics
            </NavLink>

            {/* ✅ ADDED: Journey Logs Link */}
            <NavLink to="/journey-logs" className={({ isActive }) => isActive ? "active-link" : ""}>
              📂 Journey Logs & Billing
            </NavLink>
          </>
        )}

        {(permissions.subscribers || permissions.super_admin) && (
          <NavLink to="/subscribers" className={({ isActive }) => isActive ? "active-link" : ""}>
            💳 Subscribers
          </NavLink>
        )}

        {(permissions.admin_access || permissions.super_admin) && (
          <NavLink to="/access" className={({ isActive }) => isActive ? "active-link" : ""}>
            🔐 Access Management
          </NavLink>
        )}

        {(permissions.notifications || permissions.super_admin) && (
          <NavLink to="/notifications" className={({ isActive }) => isActive ? "active-link" : ""}>
            🔔 Push Notifications
          </NavLink>
        )}
      </nav>

      <button 
        onClick={handleLogout} 
        style={{
          background: 'transparent',
          color: '#ef4444',
          border: 'none',
          padding: '20px',
          cursor: 'pointer',
          textAlign: 'left',
          fontSize: '16px',
          fontWeight: 'bold',
          borderTop: '1px solid #374151'
        }}
      >
        🚪 Sign Out
      </button>
    </div>
  );
};

export default Sidebar;